var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.7657 2.25938L25.972 11.8531C26.2939 12.5875 26.9907 13.0906 27.7907 13.1625L38.0376 14.0813C39.197 14.25 39.6595 15.6719 38.8189 16.4906L31.1001 22.975C30.4751 23.5 30.1907 24.325 30.3626 25.1219L32.6064 35.625C32.8032 36.7781 31.5939 37.6594 30.5564 37.1125L21.6126 31.875C20.9251 31.4719 20.0751 31.4719 19.3876 31.875L10.4439 37.1094C9.40948 37.6531 8.19698 36.775 8.39386 35.6219L10.6376 25.1187C10.8064 24.3219 10.5251 23.4969 9.90011 22.9719L2.17823 16.4937C1.34073 15.6781 1.80323 14.2531 2.95948 14.0844L13.2064 13.1656C14.0064 13.0938 14.7032 12.5906 15.0251 11.8562L19.2314 2.2625C19.7532 1.2125 21.247 1.2125 21.7657 2.25938Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.4594 12.4285L20.7469 5.35977C20.7187 4.96602 20.6375 4.29102 21.2687 4.29102C21.7687 4.29102 22.0406 5.33164 22.0406 5.33164L24.1781 11.0066C24.9844 13.166 24.6531 13.9066 23.875 14.3441C22.9812 14.8441 21.6625 14.4535 21.4594 12.4285Z",
    fill: "#FFFF8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.2751 22.347L36.4063 17.5626C36.7095 17.3095 37.2563 16.9063 36.8188 16.447C36.472 16.0845 35.5345 16.6063 35.5345 16.6063L30.1688 18.7032C28.5688 19.2563 27.5063 20.0751 27.4126 21.1063C27.2907 22.4813 28.5251 23.5407 30.2751 22.347Z",
    fill: "#F4B400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3e7ea43d832d5bb63f252d7f6aa4a961.svg";
export { ForwardRef as ReactComponent };